import React from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import ErrorMessage from '../../ErrorMessage';
import Loading from '../../utility/Loading';
import Checkmark from '../../utility/Checkmark';

export const checkJobStatusInterval = (identifier, checkJobStatus) => {
  let intervalId;
  let count = 0;
  return new Promise((resolve) => {
    intervalId = setInterval(async () => {
      const response = await checkJobStatus(identifier);
      if (response?.status === 'SUCCESS' || response?.status === 'FAILURE') {
        clearInterval(intervalId);
        resolve(response);
      }

      // timeout after a fixed number of checks as a fail safe
      if (++count > 60) {
        clearInterval(intervalId);
        resolve({ status: 'TIMEOUT' });
      }
    }, 5000);
  });
};

export const displayLoadingOrSuccess = (
  tenantName,
  loading,
  success,
  updateType
) => {
  if (loading) {
    return (
      <div className="tenant-modal__loading-container">
        <Loading height="50%" />
        <p className="tenant-modal__loading-message">
          {`Updating ${tenantName} ${updateType}...`}
        </p>
      </div>
    );
  }
  if (success) {
    return (
      <div className="tenant-modal__loading-container">
        <div className="tenant-modal__success-container">
          <Checkmark color="green" />
        </div>
        <p className="tenant-modal__loading-message">
          {`${tenantName} ${updateType} updated successfully!`}
        </p>
      </div>
    );
  }
};

export const labelAndFileSelector = (
  label,
  subText,
  id,
  callback,
  stateVal,
  styles
) => {
  return (
    <div className="tenant-modal__column tenant-modal__margin-bottom">
      <label className="tenant-modal__label">{label}</label>
      <label className="file" style={{ width: '100%' }}>
        <input
          type="file"
          id={id}
          accept={
            label.includes('Hero') || label.includes('Logo')
              ? 'image/png, image/jpeg'
              : '.csv'
          }
          aria-label="File browser"
          onChange={(e) => {
            callback(e);
          }}
        />
        <span className="tenant-modal__selected-file-name">
          {stateVal?.name || ''}
        </span>
        <span className={classNames('file-custom', styles)} />
      </label>
      {subText && <p className="tenant-modal__subText">{subText}</p>}
    </div>
  );
};

export const labelAndInput = (
  id,
  label,
  className,
  stateVal,
  callback,
  errorMessage,
  errorPresent
) => {
  return (
    <div className={classNames('tenant-modal__label-and-input', className)}>
      <label className="tenant-modal__label" htmlFor={id}>
        {label}
      </label>
      <input
        className="tenant-modal__input"
        id={id}
        value={stateVal || ''}
        onChange={(e) => {
          callback(id, e.target.value);
        }}
        maxLength={id === 'primary' || id === 'secondary' ? '7' : 'none'}
      />
      {(id === 'primary' || id === 'secondary') && (
        <div
          className="tenant-modal__color-block"
          style={{ backgroundColor: `${stateVal}` }}
        />
      )}
      {id === 'name' && (
        <p className="tenant-modal__subText">
          {`www.me3.careers/${stateVal.toLowerCase()}`}
        </p>
      )}
      <ErrorMessage error={errorMessage} hidden={!errorPresent} />
    </div>
  );
};

export const effectiveDateSection = (
  stateEffectiveMonth,
  monthCallback,
  monthErrorMessage,
  monthError,
  stateEffectiveYear,
  yearCallback,
  yearErrorMessage,
  yearError
) => {
  const months = [
    { value: 'January', label: 'January' },
    { value: 'February', label: 'February' },
    { value: 'March', label: 'March' },
    { value: 'April', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'June', label: 'June' },
    { value: 'July', label: 'July' },
    { value: 'August', label: 'August' },
    { value: 'September', label: 'September' },
    { value: 'October', label: 'October' },
    { value: 'November', label: 'November' },
    { value: 'December', label: 'December' },
  ];

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 11,
    }),
  };

  return (
    <div className="tenant-modal__terms-date-section">
      <div
        className={classNames(
          'tenant-modal__label-and-input tenant-modal__leave-room'
        )}
      >
        <label className="tenant-modal__label" htmlFor="effectiveDateMonth">
          Effective Month
        </label>
        <div className="tenant-modal__month-year-container">
          <Select
            options={months}
            placeholder="Month"
            value={stateEffectiveMonth}
            styles={customStyles}
            onChange={(e) => monthCallback(e)}
          />
        </div>
        <ErrorMessage error={monthErrorMessage} hidden={!monthError} />
      </div>
      <div
        className={classNames(
          'tenant-modal__label-and-input tenant-modal__leave-room'
        )}
      >
        <label className="tenant-modal__label" htmlFor="effectiveDateYear">
          Effective Year
        </label>
        <input
          className="tenant-modal__input"
          type="text"
          maxLength="4"
          value={stateEffectiveYear}
          onChange={(e) => yearCallback(e)}
        />
        <ErrorMessage error={yearErrorMessage} hidden={!yearError} />
      </div>
    </div>
  );
};

export const checkButtonErrors = (dashButtons) => {
  let buttonErrors = false;
  dashButtons.map((stateObj) => {
    Object.values(stateObj).map((buttonArray) => {
      buttonArray.map((button) => {
        if (button.isDropdown && buttonArray.length === 1) {
          buttonErrors = true;
        }
        if (button.isDropdown && !button.label) {
          buttonErrors = true;
        }
        if (!button.isDropdown && (!button.label || !button.value)) {
          buttonErrors = true;
        }
        if (
          !button.isDropdown &&
          !button.value.includes('http://') &&
          !button.value.includes('https://')
        ) {
          buttonErrors = true;
        }
      });
    });
  });
  return buttonErrors;
};

export const checkboxAndLabel = (label, stateVal, callback) => {
  return (
    <div className="tenant-modal__checkbox-and-label tenant-modal__margin-bottom">
      <input
        type="checkbox"
        className="tenant-modal__checkbox"
        name="terms-type"
        id={label}
        onClick={() => {
          callback();
        }}
        tabIndex={0}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) callback();
        }}
        onChange={() => {
          // this is to appease react, but we want an onClick here
          // rather than an onChange - despite the fact that react
          // wants us to have an onChange
        }}
        checked={stateVal}
      />
      <label
        htmlFor={label}
        className="tenant-modal__label tenant-modal__no-margin"
      >
        {label}
      </label>
    </div>
  );
};
